import { axiosInstance, risingInstance } from "../baseApi";
// import { getRisingToken, getRisingUserInfo } from "../authToken";
// const risingHost = process.env.VUE_APP_API_BASE_URL;
const authUrl = process.env.VUE_APP_BOT_URL;
axiosInstance.defaults.headers["SECRET-KEY"] = process.env.VUE_APP_BOT_SECRET;

export async function registerBotAPI(
  user,
  leverage,
  loss,
  profit,
) {
  let url = "/position-bot/settings";
    return axiosInstance.post(`${authUrl}${url}`, {
      leverage: Number(leverage),
      loss: Number(loss),
      profit: Number(profit),
      user_no: Number(user),
      exchange: 1 
    });
}

export async function activeBotAPI(user, status) {
  let url = "/position-bot/active";
  return axiosInstance.post(`${authUrl}${url}`, {
    user_no: user,
    active: status,
    exchange: 1,
  });
}

export async function getBotAPI(user) {
  let url = "/position-bot/view";
  let params =
    {
      user_no: user,
      exchange: 1
    }

  return axiosInstance.get(`${authUrl}${url}`, {
    params: params,
  });

}
